import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        spanWrapper: {
            display: 'block',
        },
    }
})

export default useStyles
